// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableTotal[data-v-0d436f40]{border:1px solid #ccc!important;padding:10px;display:flex;font-size:14px;color:#606166}.tableTotal div[data-v-0d436f40]{flex:6;display:flex;justify-content:space-around}", ""]);
// Exports
module.exports = exports;
